module.exports = __webpack_public_path__ + "img/Res_Mus_7kl.80286b3f.jpg";